import { Row, Col, Input, Space } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';

import { Form, UploadFile, FormButton } from 'common/components';
import { QaSpecHelpContentLabel } from 'pages/qa-spec/components/shared/QaSpecHelpContent';

import * as productEndpoints from 'services/product/endpoints';

import { UPLOAD_MAX_SIZE } from 'static/Constants';
import { SUPPORT_TYPES } from './constants';
import { TOOlTIP_FIELDS } from 'static/tooltipFields';
import TraceableCommentContainer from 'pages/traceable-comment/TraceableCommentContainer';

export const FormUploadAsset = (props) => {
  return (
    <div style={{ height: 300, marginTop: 12 }}>
      <UploadFile
        multiple={false}
        multipleImport={false}
        supportTypes={SUPPORT_TYPES}
        showSubmitBtn
        showList
        manualUpload
        showPreview
        showMultiple={false}
        apiUrl={productEndpoints.UPLOAD_PIM_ASSET}
        maxSize={UPLOAD_MAX_SIZE.GENERAL}
        {...props}
      />
    </div>
  );
};

export const FormDocumentName = ({
  formInstance,
  isSubmitting,
  onBack,
  onSubmitForm,
}) => {
  return (
    <Form style={{ height: 350 }} form={formInstance} onFinish={onSubmitForm}>
      <Row style={{ flexDirection: 'column', height: '100%', paddingTop: 30 }}>
        <Col>
          <Form.Item
            label={
              <TraceableCommentContainer
                qaSpecName='Manufacturing Process'
                qaSpecFieldName='Document Name'
              >
                <QaSpecHelpContentLabel
                  fieldPath={TOOlTIP_FIELDS.documentName.fieldPath}
                >
                  Document Name
                </QaSpecHelpContentLabel>
              </TraceableCommentContainer>
            }
            name='documentName'
          >
            <Input />
          </Form.Item>
        </Col>
        <Col flex={1}></Col>
        <Col>
          <Space style={{ float: 'right' }}>
            <FormButton
              type='default'
              icon={<ArrowLeftOutlined />}
              text='Back to asset creation'
              onClick={onBack}
            />
            <FormButton
              htmlType='submit'
              text='Complete Setup'
              loading={isSubmitting}
            />
          </Space>
        </Col>
      </Row>
    </Form>
  );
};
